import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';

export class OrderModel {
  public id: number;
  public title: string;
  public body: string;
  public category: DictionaryItemDTO = new DictionaryItemDTO(0, null);
  public client: DictionaryItemDTO;
  public clientPhone: string;
  public createDate: Date;
  public employee: EmployeeDTO;
  public coordinator: EmployeeDTO;
  public employeeFor: EmployeeDTO;
  public lastComment: string;
  public lastCommentDate: string;
  public mark: number;
  public plannedExecDate: Date;
  public expectExecDate: Date;
  public lastExecutor: EmployeeDTO;
  public resource: DictionaryItemDTO;
  public service: DictionaryItemDTO;
  public status: StatusDTO;
  public task: DictionaryItemDTO;
  public urgency: DictionaryItemDTO;
  public properties: PropertyValueDTO[];
  public files: RequestFileDTO[];
  public orderReact911Time: number;
  public orderTime: number;
  public overallOrderTime: number;
  public totalReact911Time: number;
  public totalExecTime: number;
  public execCountdown: number;
  public isPaused: boolean;
  public sort: Date;

  public canEditCategory: boolean = true;
  public addedFiles: any[] = [];

  static copy(source: OrderModel): OrderModel {
    if (!source) {
      return null;
    }

    let result = new OrderModel();
    result.id = source.id;
    result.title = source.title;
    result.body = source.body;
    result.category = { ...source.category };
    result.client = source.client ? { ...source.client } : null;
    result.clientPhone = source.clientPhone;
    result.createDate = source.createDate;
    result.employee = source.employee ? { ...source.employee } : null;
    result.coordinator = source.coordinator ? { ...source.coordinator } : null;
    result.employeeFor = source.employeeFor ? { ...source.employeeFor } : null;
    result.lastComment = source.lastComment;
    result.lastCommentDate = source.lastCommentDate;
    result.mark = source.mark;
    result.plannedExecDate = source.plannedExecDate;
    result.expectExecDate = source.expectExecDate;
    result.lastExecutor = source.lastExecutor ? { ...source.lastExecutor } : null;
    result.resource = { ...source.resource };
    result.service = { ...source.service };
    result.status = { ...source.status };
    result.task = { ...source.task };
    result.urgency = { ...source.urgency };

    if (source.properties) {
      result.properties = [...source.properties];
    }

    if (source.files) {
      result.files = [...source.files];
    }

    result.canEditCategory = source.canEditCategory;
    return result;
  }
}

export class DictionaryItemDTO {
  constructor(
    public id: number,
    public value: string
  ) {}
}

export class EmployeeDTO {
  constructor(
    public id: number,
    public fio: string
  ) {}
}

export class PropertyValueDTO {
  public property: PropertyDTO;
  public entityValue: T22EntityItemDTO;
  public value: string;
}

export class PropertyDTO {
  public name: string;
  public dictionary: PropertyDictionaryDTO;
  public type: DictionaryItemDTO;
  constructor(public id: number) {}
}

export class PropertyDictionaryDTO {
  public id: number;
  public name: string;
  public entity: T22EntityDTO;
}

export class T22EntityDTO {
  public id: number;
  public name: string;
  public rootType: number;
  public rowsCountLimit: number;
}

export class T22EntityItemDTO {
  public id: string;
  public name: string;
  public parentId: string;
}

export class RequestTemplateDTO {
  public id: number;
  public name: string;
  public requestNeedAgree: boolean;
  public requestTemplateDescs: RequestTemplateDescDTO[];
  public typeId: number;
}

export class RequestTemplateDescDTO {
  public id: number;
  public mandatory: boolean;
  public property: PropertyDTO;
  public sortOrder: number;
}

export class RequestFileDTO {
  public id: number;
  public fileName: string;
  public fileSize: number;
  public fileAuthor: EmployeeDTO;
  public fileAddDate: Date;
  public fileDate: Date;
}

export class StatusDTO {
  constructor(
    public id: number,
    public name: string
  ) {}
}

export class RequestActDTO {
  public id: number;
  public requestId: number;
  public date: Date;
  public appType: number;
  public type: number;
  public typeName: string;
  public status: StatusDTO;
  public employee: EmployeeDTO;
  public adminStructure: DictionaryItemDTO;
  public mark: number;
  public message: boolean;
  public description: string;
  public coordinator: EmployeeDTO;
}

export class OrdersForNotification {
  typeId: number;
  countOrders: number;
  orders: OrderModel[];
}

export enum NotificationForOrdersType {
  estimate = 1,
  agreement,
  message,
  info,
}

export class BellOrders {
  estimate: OrderModel[] = [];
  agreement: OrderModel[] = [];
  message: OrderModel[] = [];
  info: OrderModel[] = [];
}

export enum EstimateMark {
  bad = 1,
  fine,
  great,
}
